import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";
import styled from "styled-components";
import tw from "twin.macro";

import { MdAddCircle } from "react-icons/md";

const StyledButton = styled(Button)`
  && {
    ${tw`bg-white p-3 hover:bg-gray-100`}
  }
`;

const InvoiceHeader = () => {
  const history = useHistory();

  const handleAdhocInvoice = () => history.push("/create-adhocInvoice");

  // //   const handleAddMembership = () => {
  // //     history.push("/add-membership");
  // //   };

  // //   const handleUpdateMembership = () => history.push("/update-membership");

  return (
    // <div className="py-8 px-16">
    <div className="lg:flex items-center justify-between">
      <div className="text-3xl font-rubik font-bold leading-10">
        <h3>Invoices</h3>
      </div>
      <div className="lg:flex inline-block justify-between">
        <div className="mr-6 lg:my-0 my-4">
          <StyledButton onClick={handleAdhocInvoice} endIcon={<MdAddCircle />}>
            <span className="font-display font-medium text-xs md:text-sm tracking-widest">
              ADHOC Invoices
            </span>
          </StyledButton>
        </div>
      </div>
    </div>
    // </div>
  );
};

export default InvoiceHeader;
